import { render, staticRenderFns } from "./AddForm.vue?vue&type=template&id=d4bab0e8&"
import script from "./AddForm.vue?vue&type=script&lang=js&"
export * from "./AddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports